import styled, { css } from 'styled-components'
import { Block, Tooltip as StyledTooltip } from '@mote/ui'

const GOLDEN_RATIO = {
  width: 287,
  height: 177
}

export const Wrapper = styled.div`
  font-family: 'DM Sans', sans-serif !important;
  width: ${({ width = `${GOLDEN_RATIO.width}px` }) => width};
  outline: transparent solid 2px !important;
  outline-offset: 2px;

  * {
    box-sizing: border-box;
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #ececf3;
  border-radius: 8px;
  height: 100%;
  width: 100%;
  min-height: ${({ height = `${GOLDEN_RATIO.height}px` }) => height};
`

export const Header = styled.div`
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Body = styled.div`
  background: #ffffff;
  border-radius: 8px;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #646f7b;
  background: #f6f6f9;
  padding: 8px 12px;
  border-top: 1px solid #ececf3;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`

export const ControlsContainer = styled.div`
  ${({ isTranscriptionVisible }) =>
    isTranscriptionVisible &&
    css`
      margin-top: 8px;
    `}
`

export const ScrubberContainer = styled.div`
  position: relative;
`

export const ScrubberWrapper = styled.div`
  padding: 0 16px;
`

export const CloseIconContainer = styled.span`
  z-index: 30;
  cursor: pointer;
`

export const Tooltip = styled(StyledTooltip)`
  height: inherit;
  flex-shrink: 0;

  .react-tooltip-lite {
    width: max-content !important;
  }
`
